<template>
  <v-col
    cols="12"
    class="checklist pr-4"
    :class="{checked: task.completed}"
  >
    <div class="checklist-item">
      <v-btn icon>
        <v-icon
          v-if="!task.completed"
          color="green"
          @click="toggleTaskSelected"
        >
          check_box_outline_blank
        </v-icon>
        <v-icon
          v-else
          color="green"
          @click="toggleTaskSelected"
        >
          check_box
        </v-icon>
      </v-btn>
      <div
        class="subheading pointer"
        @click="selectTask"
      >
        {{ task.name }}
      </div>
    </div>
    <div class="checklist-item--logo">
      <div v-if="task.outfox" class="logo-item red lighten-2">O</div>
      <div v-if="task.client" class="logo-item primary">C</div>
    </div>
  </v-col>
</template>

<script>
  export default {
    name: 'GettingStartedTasksList',
    props: {
      task: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      selectTask () {
        this.$router.push({
          name: 'SetupChecklistSelectedTask',
          params: {
            id: this.task.id,
            name: this.task.name.toLowerCase().split(' ').join('-')
          }})
      },
      toggleTaskSelected () {
        this.$emit('toggleTaskSelected', this.task)
      }
    }
  }
</script>

<style lang="scss">
.checklist {
  display: flex;
  justify-content: space-between;
  &:not(:last-child) {
     border-bottom: 1px solid #E0E0E0;
   }

  &.checked {
     background: #eeeeee;
   }
  }
  .checklist-item,
  .checklist-item--logo {
    display: flex;
    align-items: center;
  }
  .checklist-item--logo {
    justify-content: flex-end;
  }
  .checked-item {
    position: sticky!important;
    top: 80px;
  }
  .logo-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: white;
    font-size: 1.2rem;
    font-weight: 500;
    & + .logo-item {
      margin-left: -8px;
    }
  }
</style>
